/**
 * Simple loading spinner using Tailwind's primary color
 * @param {Object} props - Component props
 * @param {string} [props.size="small"] - Size of the loader ("small", "medium", "large")
 * @param {string} [props.message="Loading..."] - Loading message to display
 * @returns {JSX.Element} Loading spinner
 */
export const LoadingLogo = ({
  size = 'small',
  message = 'Loading your experience...',
}) => {
  const getSizeConfig = () => {
    switch (size) {
      case 'small':
        return {
          spinner: 'w-6 h-6',
          text: 'text-sm',
        };
      case 'medium':
        return {
          spinner: 'w-10 h-10',
          text: 'text-base',
        };
      case 'large':
      default:
        return {
          spinner: 'w-16 h-16',
          text: 'text-lg',
        };
    }
  };

  const sizeConfig = getSizeConfig();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="flex justify-center mb-6 flex-col items-center">
          <img src="/loading.gif" alt="Loading" className={`h-24 lg:h-48`} />
        </div>
        <div className={`${sizeConfig.text} text-gray-700 font-medium`}>
          {message}
        </div>
      </div>
    </div>
  );
};
